import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e8507df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container pt-4" }
const _hoisted_2 = { class: "d-flex justify-content-around align-items-center mt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://md.kingkit.codes/s/P0e0UzhFg",
    target: "_blank",
    class: "link-info"
  }, "教學手冊")
], -1))

import NavBar from "@/components/NavBar.vue";
import MainScreen from "@/components/MainScreen.vue";
import FolderModal from "@/components/modals/FolderModal.vue";
import TimerModal from "@/components/modals/TimerModal.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import { WebEye } from "@/utils/webEye";
import { useRoute } from "vue-router";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const deviceId = route.query.deviceId;
const store = useStore();
const webEye = new WebEye(deviceId as string);
const snapshot = () => {
  if (!store.state.folderId) {
    store.commit("setTitle", "請先設定雲端資料夾");
    return;
  }
  webEye.snapshot();
};
const setTimer = () => {
  webEye.setTimer();
};
const setFolder = () => {
  webEye.setFolder();
};

if (!deviceId) {
  store.commit("setTitle", "請掃描 WebEye Pro 遙控器 QR Code");
} else {
  webEye.connect();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar, {
      class: "mb-2",
      title: _unref(store).state.title
    }, null, 8, ["title"]),
    (_unref(deviceId))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(MainScreen, {
            loading: _unref(store).state.loading,
            imageUrl: _unref(store).state.imageUrl || ''
          }, null, 8, ["loading", "imageUrl"]),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(IconButton, {
              icon: "timer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalTimer",
              title: "設定定時拍照",
              disabled: !_unref(store).state.connected || _unref(store).state.loading
            }, null, 8, ["disabled"]), [
              [_vShow, _unref(store).state.timer]
            ]),
            _withDirectives(_createVNode(IconButton, {
              icon: "timer_off",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalTimer",
              title: "設定定時拍照",
              disabled: !_unref(store).state.connected || _unref(store).state.loading
            }, null, 8, ["disabled"]), [
              [_vShow, !_unref(store).state.timer]
            ]),
            _createVNode(IconButton, {
              icon: "photo_camera",
              title: "拍攝一張照片",
              onClick: snapshot,
              disabled: !_unref(store).state.connected || _unref(store).state.loading
            }, null, 8, ["disabled"]),
            _createVNode(IconButton, {
              icon: "folder",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalFolder",
              title: "設定雲端資料夾",
              disabled: !_unref(store).state.connected || _unref(store).state.loading
            }, null, 8, ["disabled"])
          ]),
          _hoisted_3,
          (_openBlock(), _createBlock(_Teleport, { to: "#modalWrapper" }, [
            _createVNode(TimerModal, {
              id: "modalTimer",
              callback: setTimer
            })
          ])),
          (_openBlock(), _createBlock(_Teleport, { to: "#modalWrapper" }, [
            _createVNode(FolderModal, {
              id: "modalFolder",
              callback: setFolder
            })
          ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})